import "./index.css";
import "./main.scss";

import App from "./App";
import { Provider } from 'react-redux';
import store from './store';
import { setDarkMode } from './actions';

import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Could not find root element');
}

const initializeDarkMode = () => {
  const savedDarkMode = localStorage.getItem('darkMode');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const shouldBeDark = savedDarkMode !== null ? savedDarkMode === 'true' : prefersDark;
  
  store.dispatch(setDarkMode(shouldBeDark));
  
  const root = document.documentElement;
  if (shouldBeDark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
};

initializeDarkMode();

store.subscribe(() => {
  const state = store.getState();
  const darkMode = state.ui?.darkMode;
  if (darkMode !== undefined) {
    localStorage.setItem('darkMode', String(darkMode));
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }
});

const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);